var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.78965,
    cy: 3.63902,
    rx: 2.38902,
    ry: 2.38902,
    stroke: "#6C5DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00001 9.35078C1.99937 9.18283 2.03693 9.01694 2.10985 8.86565C2.33868 8.40799 2.98399 8.16542 3.51946 8.05558C3.90564 7.97317 4.29715 7.91811 4.69108 7.89082C5.42042 7.82676 6.15397 7.82676 6.8833 7.89082C7.2772 7.91843 7.66869 7.97348 8.05493 8.05558C8.5904 8.16542 9.23571 8.3851 9.46454 8.86565C9.61119 9.17405 9.61119 9.53208 9.46454 9.84048C9.23571 10.321 8.5904 10.5407 8.05493 10.646C7.6692 10.7318 7.27755 10.7884 6.8833 10.8153C6.28968 10.8656 5.69329 10.8748 5.09841 10.8428C4.96111 10.8428 4.82838 10.8428 4.69108 10.8153C4.29832 10.7887 3.90816 10.7321 3.52404 10.646C2.98399 10.5407 2.34326 10.321 2.10985 9.84048C2.0373 9.68744 1.99978 9.52015 2.00001 9.35078Z",
    stroke: "#6C5DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f8e8de924276f3925cd4f2e3e335ac21.svg";
export { ForwardRef as ReactComponent };